import { DownloadWrapper } from '@features/flexible-reports';
import {
  GridActionsCellItem,
  GridActionsCellItemProps,
} from '@mui/x-data-grid';

type DownloadButtonProps = {
  gridActionsCellItemProps: GridActionsCellItemProps;
  campaignId: number;
  flexibleReportRequestId: number;
};

export const DownloadButton = (props: DownloadButtonProps) => {
  const { campaignId, flexibleReportRequestId } = props;

  return (
    <DownloadWrapper
      campaignId={campaignId}
      flexibleReportRequestId={flexibleReportRequestId}
      render={({ onClick }) => (
        <GridActionsCellItem
          {...props.gridActionsCellItemProps}
          onClick={onClick}
        />
      )}
    />
  );
};
